import React, { FC } from 'react';

const NotFoundPage: FC = () => {
    return <>404 Not Found</>;
};

export default NotFoundPage;
